<script lang="ts">
    import { createEventDispatcher, onDestroy, onMount } from "svelte"
    import Notification from "./Notification.svelte"
    import hash from "object-hash"
    import Cta from "./CTA.svelte"

    export let showCloseIcon: boolean = true,
        show: boolean = false,
        size: string = "md",
        cssClass: string = "",
        closeOnBackdrop: boolean = false,
        mainModal = false,
        contentId = String(Math.random()),
        catchAccidentalExit = {
            active: false,
            originalHash: "",
            currentObject: {},
        }
    let dialog: HTMLDialogElement,
        dispatch = createEventDispatcher()
    function closeModalSteps() {
        document.body.classList.remove("no-overflow")
        dialog.classList.remove("dialog-open")
        dialog.close()
        show = false
        dispatch("close")
    }
    const onCancel = (e: any) => {
            if (closeModal()) {
                closeModalSteps()
            }
        },
        onDialogClick = (e: MouseEvent) => {}

    $: if (dialog)
        if (show) {
            dialog.showModal()
            document.body.classList.add("no-overflow")
            dialog.classList.add("dialog-open")
        } else if (dialog.classList.contains("dialog-open")) {
            if (closeModal()) closeModalSteps()
        }

    onMount(() => {
        return () => {
            dialog.classList.remove("dialog-open")
            document.body.classList.remove("no-overflow")
        }
    })
    onDestroy(() => {
        if (dialog) dialog.close()
        document.body.classList.remove("no-overflow")
    })
    let catchAccidentalExitModal = false

    function closeModal(force = false) {
        if (catchAccidentalExit.active && !force)
            if (catchAccidentalExit.originalHash !== hash(catchAccidentalExit.currentObject || {})) {
                catchAccidentalExitModal = true

                return false
            }
        return true
    }
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog
    class="modal {size ? 'modal-' + size : ''} {cssClass}"
    bind:this="{dialog}"
    on:cancel="{onCancel}"
    on:click|stopPropagation="{onDialogClick}"
    on:keypress
    data-cy="modal"
    class:mainModal="{mainModal}"
>
    {#if $$slots.header}
        <section class="modal-header">
            <slot name="header" />
            {#if showCloseIcon}
                <button
                    class="modal-close"
                    on:click|stopPropagation="{() => {
                        if (closeModal()) {
                            closeModalSteps()
                        }
                    }}"
                    on:keydown
                >
                    <img
                        src="../../../assets/icons/solar_close-circle-outline{mainModal ? '-white' : ''}.svg"
                        alt="icon"
                    />

                    <slot name="close" />
                </button>
            {/if}
        </section>
    {/if}
    {#if $$slots.default}
        <section
            class="modal-content"
            id="{contentId}"
        >
            <slot />
        </section>
    {/if}
    {#if $$slots.footer}
        <section class="modal-footer">
            <slot name="footer" />
        </section>
    {/if}
    {#if catchAccidentalExitModal}
        <svelte:self
            showCloseIcon="{false}"
            show="{catchAccidentalExitModal}"
            size="sm"
            cssClass="catchAccidentalExitModal"
        >
            <div
                slot="header"
                class="label title"
                style="display: flex; gap: 1.2rem; align-items: center;"
            >
                <img
                    src="../../../assets/icons/solar_file-text-outline.svg"
                    alt="icon"
                />
                <p style="color: white;">Eintrag wurde nicht Gespeichert</p>
            </div>
            <p style="padding: 1.2rem;">
                Sie haben ungespeicherte Daten, möchten Sie den Eintrag dennoch ungespeichert verlassen?
            </p>

            <div slot="footer">
                <Cta
                    icon="solar_close-circle-outline"
                    type="tertiaryButton"
                    content="Abbrechen"
                    on:click="{(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        catchAccidentalExitModal = false
                    }}"
                />
                <Cta
                    icon="solar_login-outline"
                    type="primaryButton"
                    content="Verlassen"
                    on:click="{(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        catchAccidentalExitModal = false
                        closeModalSteps()
                    }}"
                />
            </div>
        </svelte:self>
    {/if}

    <Notification force="{true}" />
</dialog>

<style
    lang="less"
    global
>
    @import "../../../assets/variables.less";
    dialog {
        &.modal {
            background-color: var(--white-100);

            box-shadow: 0px 0px 1.2rem 0px #1e1e1e;
            border-radius: 1.2rem;
            max-height: 80vh;
            .modal-close {
                height: 100%;
                display: flex;
                align-items: flex-start;
            }
            .modal-header {
                padding: 1.2rem;
                display: flex;
                width: 100%;
                position: relative;
                justify-content: space-between;
                align-items: flex-start;
                overflow: hidden;
                border-radius: 1.2rem 1.2rem 0px 0px;
            }
            &.mainModal {
                padding: 0px;

                .modal-header {
                    padding: 1.2rem;
                    height: fit-content;
                    background-color: var(--text-000);
                }
            }
            .modal-content {
                display: flex;
                flex-direction: column;
                padding: 1.2rem;
                gap: 2.4rem;
                margin-bottom: 0.5rem;
                width: 100%;
                overflow-y: scroll;
                max-height: 60vh;
            }
            &.mainModal {
                padding: 0px;
            }
            .modal-footer {
                & > div {
                    display: flex;
                    justify-content: space-between;
                    gap: 1.2rem;
                    @media @mobile {
                        gap: 0.3rem;
                    }
                }
                display: flex;
                padding: 1.2rem;
            }

            .modal-footer  {
                background-color: var(--grey-300);
                padding: 0.6rem 1.2rem;
                border-radius: 0px 0px 1.2rem 1.2rem;
            }
            cursor: default;
            border: 0px solid black;
            transition: all 0.4s ease-in-out;
            display: flex;
            flex-direction: column;
            z-index: 9998;
            position: relative;
            display: none;

            &::backdrop {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.5);
            }
            &.modal-xs {
                width: 30vw;
                max-height: 90vh;
            }

            &.modal-sm {
                width: 40vw;
                max-height: 90vh;

                @media screen and (max-width: 1250px) {
                    width: 50vw;
                }
                @media screen and (max-width: 1050px) {
                    width: 60vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-md {
                width: 50vw;
                max-height: 90vh;

                @media screen and (max-width: 1250px) {
                    width: 60vw;
                }
                @media screen and (max-width: 1050px) {
                    width: 70vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-lg {
                width: 60vw;
                max-height: 90vh;

                @media screen and (max-width: 1250px) {
                    width: 70vw;
                }
                @media screen and (max-width: 1050px) {
                    width: 80vw;
                }
                @media screen and (max-width: 768px) {
                    width: 95vw;
                }
            }

            &.modal-xl {
                width: 80vw;
                max-height: 90vh;

                @media screen and (max-width: 1050px) {
                    width: 90vw;
                }
                @media screen and (max-width: 768px) {
                    width: 100vw;
                    max-width: 100vw !important;
                    max-height: 90vh !important;
                }
            }

            &.modal-full {
                width: 98vw;
                height: 98vw;
                max-height: 90vh;
            }

            &[open] {
                display: flex;
                flex-direction: column;
                opacity: 1;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                overflow: visible !important;
            }
        }
    }
</style>
